// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"f2d0b12c","423":"7aae8975","570":"8b1ca7b1"}[chunkId] + ".chunk.css";
};